(()=>{
  function boot(scope=document){
    const roots=[];
    if(scope && scope.matches && scope.matches('[data-s4f-root]')) roots.push(scope);
    if(scope && scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-s4f-root]'));
    [...new Set(roots)].forEach(initStore);
  }

  boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:reorder',()=>boot(document));

  function initStore(ROOT){
    if(!ROOT || ROOT.dataset.ready==='1') return;
    ROOT.dataset.ready='1';

    const PRODUCTS=JSON.parse(ROOT.querySelector('[data-s4f-products-json]')?.textContent||'[]');
    const ROUTE=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const SOURCE=(ROOT.dataset.sourceLabel||'Sense4FIT').trim();
    const STICKY_ON=ROOT.dataset.stickyCart!=='false';
    const LOW_STOCK=Math.max(3,Number(ROOT.dataset.lowStockThreshold)||10);
    const CRITICAL_STOCK=Math.max(1,Math.min(LOW_STOCK,Number(ROOT.dataset.criticalStockThreshold)||4));
    const SHOW_EXACT=ROOT.dataset.showExactStock!=='false';
    const FREE_SHIPPING_THRESHOLD=Math.max(0,Number(ROOT.dataset.freeShippingThreshold)||275);
    const SHIPPING_FEE=Math.max(0,Number(ROOT.dataset.shippingFee)||20);
    const $=(s,r=ROOT)=>r.querySelector(s);
    const $$=(s,r=ROOT)=>[...r.querySelectorAll(s)];
    const productMap=new Map(PRODUCTS.map(p=>[p.handle,p]));
    const state={cart:null,voucher:sessionStorage.getItem('s4f_activation_voucher')||'',productStates:new Map()};

    if(ROOT.dataset.microsite==='true') document.body.classList.add('s4f-microsite-mode');
    if(ROOT.dataset.hideFooter==='true') document.body.classList.add('s4f-hide-theme-footer');

    const money=cents=>new Intl.NumberFormat('ro-RO',{style:'currency',currency:'RON',minimumFractionDigits:2}).format((Number(cents)||0)/100).replace('RON','lei');
    const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
    const normRule=s=>String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'');
    function parsedEventStockRules(p){
      if(!p)return[];
      if(Array.isArray(p._eventStockRules))return p._eventStockRules;
      const raw=String(p.eventStockRulesRaw||'').trim();
      p._eventStockRules=raw.split(/\r?\n/).map(line=>{
        const m=line.match(/^(.+?)\s*=\s*(\d+)\s*$/);
        if(!m)return null;
        const parts=m[1].split('|').map(x=>normRule(x)).filter(Boolean);
        if(!parts.length)return null;
        return {parts,qty:Math.max(0,Number(m[2])||0),raw:line.trim()};
      }).filter(Boolean);
      return p._eventStockRules;
    }
    function manualStockCap(p,displayVariant){
      if(!p||!displayVariant)return null;
      const options=((displayVariant.options)||[]).map(normRule);
      const title=normRule(displayVariant.title||'');
      const rule=parsedEventStockRules(p).find(r=>r.parts.every(part=>options.includes(part)||title.includes(part)));
      return rule?rule.qty:null;
    }
    function manualStockRule(p,displayVariant){
      if(!p||!displayVariant)return null;
      const options=((displayVariant.options)||[]).map(normRule);
      const title=normRule(displayVariant.title||'');
      return parsedEventStockRules(p).find(r=>r.parts.every(part=>options.includes(part)||title.includes(part)))||null;
    }
    function variantDiscountMeta(p,v){
      const options=((v&&v.options)||[]).map(normRule);
      const titleParts=String(v?.title||'').split(/[\/|·-]/).map(normRule).filter(Boolean);
      const rules=(p?.variantDiscountRules||[]).filter(r=>String(r?.match||'').trim());
      const rule=rules.find(r=>{
        const target=normRule(r.match);
        return options.includes(target)||titleParts.includes(target);
      });
      const percent=Math.max(0,Math.min(100,Number(rule?rule.discountPercent:p?.discountPercent)||0));
      const code=String((rule&&rule.discountCode)||p?.discountCode||'').trim();
      return {percent,code,match:rule?String(rule.match||''):''};
    }
    const hasEventProduct=p=>Boolean(p&&p.eventProduct&&String(p.eventProduct.id)!==String(p.id)&&Array.isArray(p.eventProduct.variants)&&p.eventProduct.variants.length);
    const sameOptions=(a,b)=>Array.isArray(a)&&Array.isArray(b)&&a.length===b.length&&a.every((x,i)=>normRule(x)===normRule(b[i]));
    function eventVariantFor(p,displayVariant){
      if(!hasEventProduct(p)||!displayVariant) return null;
      const evs=p.eventProduct.variants||[];
      return evs.find(ev=>sameOptions(ev.options,displayVariant.options))
        ||evs.find(ev=>normRule(ev.title)===normRule(displayVariant.title))
        ||null;
    }
    function displayVariantForEvent(p,eventVariant){
      if(!p||!eventVariant) return null;
      return (p.variants||[]).find(v=>sameOptions(v.options,eventVariant.options))
        ||(p.variants||[]).find(v=>normRule(v.title)===normRule(eventVariant.title))
        ||null;
    }
    const saleVariantFor=(p,displayVariant)=>eventVariantFor(p,displayVariant)||displayVariant||null;
    function cartQtyForDisplayVariant(p,displayVariant){
      if(!p||!displayVariant)return 0;
      const pid=String(displayVariant.id||'');
      return eventItems().reduce((sum,item)=>{
        if(String(item?.properties?._S4FDisplayHandle||'')!==String(p.handle||''))return sum;
        if(String(item?.properties?._S4FDisplayVariantId||'')!==pid)return sum;
        return sum+Math.max(0,Number(item.quantity)||0);
      },0);
    }
    function stockLimitFor(p,displayVariant,saleVariant,dedicated){
      const base=maxStock(saleVariant,dedicated);
      const cap=manualStockCap(p,displayVariant);
      if(cap==null)return base;
      if(!saleVariant||!saleVariant.available)return 0;
      if(base===99)return cap;
      return Math.max(0,Math.min(base,cap));
    }
    function remainingStockFor(p,displayVariant,saleVariant,dedicated){
      const limit=stockLimitFor(p,displayVariant,saleVariant,dedicated);
      if(limit===99)return 99;
      return Math.max(0,limit-cartQtyForDisplayVariant(p,displayVariant));
    }
    const variantIsSellable=(p,displayVariant)=>{
      const sale=saleVariantFor(p,displayVariant),dedicated=hasEventProduct(p);
      return Boolean(sale&&sale.available&&remainingStockFor(p,displayVariant,sale,dedicated)>0);
    };
    function nativeEventMeta(p,displayVariant){
      const sale=eventVariantFor(p,displayVariant);
      if(!sale) return null;
      const normal=Math.max(0,Number(displayVariant&&displayVariant.price)||0);
      const event=Math.max(0,Number(sale.price)||0);
      const percent=normal>0&&event<normal?Math.max(0,Math.min(100,Math.round((1-event/normal)*100))):0;
      return {percent,code:'',match:String(displayVariant&&displayVariant.title||''),native:true,eventPrice:event,saleVariant:sale};
    }
    function pricingMeta(p,displayVariant){
      return nativeEventMeta(p,displayVariant)||({...variantDiscountMeta(p,displayVariant),native:false,eventPrice:null,saleVariant:displayVariant});
    }
    const eventPrice=(p,cents,v)=>{
      const native=nativeEventMeta(p,v);
      return native?native.eventPrice:Math.round((Number(cents)||0)*(1-variantDiscountMeta(p,v).percent/100));
    };
    function productForCartItem(item){
      const displayHandle=String(item?.properties?._S4FDisplayHandle||'').trim();
      if(displayHandle&&productMap.has(displayHandle)) return productMap.get(displayHandle);
      if(productMap.has(item?.handle)) return productMap.get(item.handle);
      return PRODUCTS.find(p=>p?.eventProduct&&p.eventProduct.handle===item?.handle)||null;
    }
    function variantByCartItem(p,item){
      if(!p||!item)return null;
      const id=String(item.variant_id||item.id||'');
      if(hasEventProduct(p)){
        const ev=(p.eventProduct.variants||[]).find(v=>String(v.id)===id);
        if(ev)return ev;
      }
      return (p.variants||[]).find(v=>String(v.id)===id)||null;
    }
    function displayVariantByCartItem(p,item){
      if(!p||!item)return null;
      const displayId=String(item?.properties?._S4FDisplayVariantId||'');
      if(displayId){const v=(p.variants||[]).find(x=>String(x.id)===displayId);if(v)return v;}
      const cartV=variantByCartItem(p,item);
      if(hasEventProduct(p)&&cartV)return displayVariantForEvent(p,cartV);
      return cartV;
    }
    const maxStock=(v,strict=false)=>{
      if(!v)return 0;
      if(v.inventoryManagement==null)return v.available?99:0;
      if(strict)return Math.max(0,Number(v.inventoryQuantity)||0);
      return v.inventoryPolicy==='continue'?(v.available?99:0):Math.max(0,Number(v.inventoryQuantity)||0);
    };
    const stockText=(v,dedicated=false)=>{
      if(!v||!v.available||maxStock(v,dedicated)===0) return dedicated?'Epuizat din stocul Sense4FIT':'Epuizat la eveniment';
      const n=maxStock(v,dedicated);
      if(n===99) return dedicated?'Stoc Sense4FIT · disponibil':'Stoc live · disponibil';
      if(n<=CRITICAL_STOCK) return SHOW_EXACT?`Doar ${n} ${n===1?'bucată rămasă':'bucăți rămase'} în stocul Sense4FIT`:'Ultimele bucăți Sense4FIT';
      if(n<=LOW_STOCK) return SHOW_EXACT?`${n} bucăți Sense4FIT rămase`:'Stoc Sense4FIT limitat';
      return dedicated?(SHOW_EXACT?`${n} bucăți alocate Sense4FIT`:'Stoc Sense4FIT · disponibil'):'Stoc live · disponibil';
    };
    const stockState=(v,dedicated=false)=>{
      if(!v||!v.available||maxStock(v,dedicated)===0) return 'sold_out';
      const n=maxStock(v,dedicated);
      if(n===99) return 'available';
      if(n<=CRITICAL_STOCK) return 'critical';
      if(n<=LOW_STOCK) return 'low';
      return 'available';
    };
    function stockTextForCount(n,dedicated=false,manual=false){
      if(n<=0)return manual?'Epuizat din alocarea Sense4FIT':(dedicated?'Epuizat din stocul Sense4FIT':'Epuizat la eveniment');
      if(n===99)return dedicated?'Stoc Sense4FIT · disponibil':'Stoc live · disponibil';
      if(n<=CRITICAL_STOCK)return SHOW_EXACT?`Doar ${n} ${n===1?'bucată rămasă':'bucăți rămase'} pentru Sense4FIT`:'Ultimele bucăți Sense4FIT';
      if(n<=LOW_STOCK)return SHOW_EXACT?`${n} bucăți Sense4FIT rămase`:'Stoc Sense4FIT limitat';
      return manual?(SHOW_EXACT?`${n} bucăți din alocarea Sense4FIT`:'Alocare Sense4FIT · disponibilă'):(dedicated?(SHOW_EXACT?`${n} bucăți alocate Sense4FIT`:'Stoc Sense4FIT · disponibil'):'Stoc live · disponibil');
    }
    function stockStateForCount(n){
      if(n<=0)return 'sold_out';
      if(n===99)return 'available';
      if(n<=CRITICAL_STOCK)return 'critical';
      if(n<=LOW_STOCK)return 'low';
      return 'available';
    }
    const isEventItem=item=>Boolean(item?.properties && (item.properties._Sense4FIT || item.properties['Sense4FIT']));
    const eventItems=()=>((state.cart&&state.cart.items)||[]).filter(isEventItem);
    const otherItems=()=>((state.cart&&state.cart.items)||[]).filter(i=>!isEventItem(i));

    function toast(msg,type){
      const w=$('[data-s4f-toasts]'); if(!w) return;
      const n=document.createElement('div');
      n.className='s4f-toast'+(type==='error'?' is-error':'');
      n.textContent=msg; w.appendChild(n);
      setTimeout(()=>{n.style.opacity='0';n.style.transform='translateY(8px)';setTimeout(()=>n.remove(),250)},2800);
    }

    function variantFromSelection(p,sel){return p.variants.find(v=>v.options.every((x,i)=>x===sel[i]))||p.variants[0]}
    function optionAvailable(p,index,value,sel){
      const copy=sel.slice(); copy[index]=value;
      return p.variants.some(v=>variantIsSellable(p,v)&&v.options.every((o,i)=>i===index?o===value:(copy[i]?o===copy[i]:true)));
    }

    function initProductCard(card){
      const p=productMap.get(card.dataset.handle); if(!p) return;
      const first=p.variants.find(v=>variantIsSellable(p,v))||p.variants[0];
      const ps={product:p,selected:first.options.slice(),variant:first,qty:1};
      state.productStates.set(p.handle,ps);
      renderOptions(card,ps); renderProduct(card,ps);
    }

    function renderOptions(card,ps){
      const box=$('[data-s4f-options]',card); if(!box) return;
      box.innerHTML='';
      ps.product.options.forEach((opt,index)=>{
        const g=document.createElement('div'); g.className='s4f-option-group';
        g.innerHTML=`<div class="s4f-option-label"><span>${esc(opt.name)}</span><b>${esc(ps.selected[index]||'')}</b></div><div class="s4f-option-values"></div>`;
        const vals=$('.s4f-option-values',g);
        opt.values.forEach(value=>{
          const b=document.createElement('button'); b.type='button'; b.textContent=value;
          if(value===ps.selected[index]) b.classList.add('is-active');
          if(!optionAvailable(ps.product,index,value,ps.selected)) b.classList.add('is-unavailable');
          b.onclick=()=>{
            ps.selected[index]=value;
            let v=variantFromSelection(ps.product,ps.selected);
            if(!v||!variantIsSellable(ps.product,v)){
              const alt=ps.product.variants.find(x=>variantIsSellable(ps.product,x)&&x.options[index]===value);
              if(alt){ps.selected=alt.options.slice();v=alt;}
            }
            ps.variant=v; ps.qty=1;
            renderOptions(card,ps); renderProduct(card,ps);
          };
          vals.appendChild(b);
        });
        box.appendChild(g);
      });
    }

    function renderProduct(card,ps){
      const v=ps.variant; if(!v) return;
      const dedicated=hasEventProduct(ps.product),saleV=saleVariantFor(ps.product,v),meta=pricingMeta(ps.product,v),ep=eventPrice(ps.product,v.price,v),save=Math.max(0,v.price-ep),manual=manualStockRule(ps.product,v),n=remainingStockFor(ps.product,v,saleV,dedicated);
      const normal=$('[data-s4f-normal-price]',card), event=$('[data-s4f-event-price]',card), addPrice=$('[data-s4f-add-price]',card), saveEl=$('[data-s4f-save]',card), qty=$('[data-s4f-qty]',card), stock=$('[data-s4f-stock-copy]',card), bar=$('[data-s4f-stockbar]',card), urgency=$('[data-s4f-urgency]',card);
      if(normal) normal.textContent=money(v.price);
      if(event) event.textContent=money(ep);
      if(addPrice) addPrice.textContent=money(ep*ps.qty);
      if(saveEl) saveEl.textContent=save?`economisești ${money(save)} / buc${meta.match?` · ofertă ${meta.match}`:''}`:'ofertă specială activă';
      if(qty) qty.textContent=ps.qty;
      if(stock) stock.textContent=saleV?stockTextForCount(n,dedicated,Boolean(manual)):(dedicated?'Varianta nu există în produsul EVENT':'Varianta indisponibilă');
      if(bar) bar.style.width=(n===99?100:Math.min(100,Math.max(8,n/15*100)))+'%';
      const sellable=Boolean(saleV&&saleV.available&&n>0);
      const av=$('[data-s4f-availability]',card); if(av) av.innerHTML=sellable?`<i></i> ${manual?'lot disponibil':(dedicated?'stoc Sense4FIT':'disponibil')}`:`<i class="is-off"></i> epuizat`;
      const badge=$('[data-s4f-stock-badge]',card),st=stockStateForCount(n);
      if(badge){
        badge.classList.remove('s4f-badge--stock','s4f-badge--sold','is-low','is-critical');
        if(st==='sold_out'){badge.classList.add('s4f-badge--sold');badge.textContent='SOLD OUT';}
        else if(st==='critical'){badge.classList.add('s4f-badge--stock','is-critical');badge.textContent=SHOW_EXACT?`ULTIMELE ${n}`:'ULTIMELE BUCĂȚI';}
        else if(st==='low'){badge.classList.add('s4f-badge--stock','is-low');badge.textContent='LOT LIMITAT';}
        else{badge.classList.add('s4f-badge--stock');badge.textContent=manual?'LOT ONLINE':'DISPONIBIL';}
      }
      if(urgency){
        if(st==='sold_out') urgency.textContent='Produsul a ieșit din lotul curent. Îl readucem când ne permite producția.';
        else if(st==='critical') urgency.textContent=`Grab it now — au rămas doar ${n} bucăți în lotul actual.`;
        else if(st==='low') urgency.textContent='Lot mic disponibil acum. După epuizare, produsul revine doar după următoarea producție.';
        else urgency.textContent='Lot online limitat, actualizat pe măsură ce produce TN.';
      }
      const eventBadge=$('[data-s4f-event-badge]',card);
      if(eventBadge){
        eventBadge.hidden=meta.percent<=0;
        eventBadge.textContent=meta.percent>0?`SPECIAL -${meta.percent}%`:'';
      }
      const add=$('[data-s4f-add]',card);
      if(add){add.disabled=!sellable;const span=add.querySelector('span');if(span)span.textContent=sellable?'Adaugă în coș':'Sold out';}
      const img=$('.s4f-product__image',card); if(img&&v.image&&img.src!==v.image){img.src=v.image;img.classList.remove('is-swap');void img.offsetWidth;img.classList.add('is-swap');}
    }

    async function ajax(path,opts){
      const r=await fetch(ROUTE+path,{credentials:'same-origin',...opts});
      let data={}; try{data=await r.json()}catch(e){}
      if(!r.ok) throw new Error(data.description||data.message||'Eroare Shopify');
      return data;
    }
    async function getCart(){state.cart=await ajax('cart.js');renderCart();return state.cart;}

    function eventCodesForCart(){
      const codes=[],used=new Set();
      eventItems().forEach(i=>{
        const p=productForCartItem(i);
        if(!p||hasEventProduct(p))return; // Dedicated EVENT SKUs already have the final Sense4FIT price.
        const v=displayVariantByCartItem(p,i);
        const code=variantDiscountMeta(p,v).code;
        if(code&&!used.has(code)){used.add(code);codes.push(code);}
      });
      return codes;
    }
    function currentCodes(){
      const arr=[...eventCodesForCart()];
      if(state.voucher) arr.push(state.voucher);
      return [...new Set(arr.filter(Boolean))];
    }

    async function applyCartMeta(){
      const payload={attributes:{'Order source':SOURCE,'Event landing page':'Sense4FIT','Offer flow':'Post-event online offers','Offer source':'TN Human Slot Machine'},note:'SENSE4FIT ONLINE OFFERS — Discounturile și produsele speciale provin din landing page-ul Sense4FIT.'};
      const codes=currentCodes();
      payload.discount=codes.join(',');
      state.cart=await ajax('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      renderCart(); return state.cart;
    }

    async function addVariant(card,ps){
      const btn=$('[data-s4f-add]',card); btn?.classList.add('is-loading'); if(btn) btn.disabled=true;
      try{
        const dedicated=hasEventProduct(ps.product),saleV=saleVariantFor(ps.product,ps.variant),meta=pricingMeta(ps.product,ps.variant);
        const remaining=remainingStockFor(ps.product,ps.variant,saleV,dedicated),rule=manualStockRule(ps.product,ps.variant);
        if(!saleV||!saleV.available||remaining<=0) throw new Error((dedicated||rule)?'Stocul Sense4FIT pentru această variantă s-a epuizat.':'Varianta nu mai este disponibilă.');
        if(remaining!==99&&ps.qty>remaining) throw new Error(`Mai sunt disponibile doar ${remaining} buc. pentru această variantă Sense4FIT.`);
        await ajax('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(saleV.id),quantity:ps.qty,properties:{'_Sense4FIT':'2026','_S4FDisplayHandle':ps.product.handle,'_S4FDisplayVariantId':String(ps.variant.id),'_S4FEventMode':dedicated?'dedicated_sku':'discount_code','_S4FEventStockRule':rule?rule.raw:'','Oferta event':dedicated?'preț EVENT fix':(meta.percent?`${meta.percent}%`:'standard'),'Regulă gramaj':meta.match||ps.variant.title||'default'}}]})});
        await getCart(); await applyCartMeta();
        card.classList.remove('is-added'); void card.offsetWidth; card.classList.add('is-added'); setTimeout(()=>card.classList.remove('is-added'),900);
        bumpSticky();
        toast(`${ps.product.title} a fost adăugat în Coșul Sense4FIT.`);
      }catch(e){toast(e.message||'Nu am putut adăuga produsul','error');}
      finally{btn?.classList.remove('is-loading');renderProduct(card,ps);}
    }

    async function changeLine(key,qty){
      try{
        state.cart=await ajax('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
        renderCart(); await applyCartMeta();
      }catch(e){toast(e.message||'Nu am putut actualiza produsul','error');}
    }

    function cartEventStats(){
      let normal=0,event=0,count=0;
      eventItems().forEach(i=>{
        const p=productForCartItem(i); if(!p) return;
        const displayV=displayVariantByCartItem(p,i);
        const normalUnit=Math.max(0,Number(displayV&&displayV.price)||Number(i.original_price)||0);
        const eventUnit=hasEventProduct(p)?Math.max(0,Number(i.original_price)||0):eventPrice(p,normalUnit,displayV);
        normal+=normalUnit*i.quantity; event+=eventUnit*i.quantity; count+=i.quantity;
      });
      return{normal,event,save:Math.max(0,normal-event),count,otherCount:otherItems().reduce((s,i)=>s+i.quantity,0)};
    }

    function renderCart(){
      const c=state.cart||{items:[]};
      const items=$('[data-s4f-cart-items]'); if(!items) return;
      const eItems=eventItems();
      items.innerHTML=eItems.length?eItems.map(i=>{
        const p=productForCartItem(i),displayV=p?displayVariantByCartItem(p,i):null,dedicated=p?hasEventProduct(p):false,meta=p?pricingMeta(p,displayV):{percent:0};
        const normalUnit=Math.max(0,Number(displayV&&displayV.price)||Number(i.original_price)||0);
        const ep=p?(dedicated?Math.max(0,Number(i.original_price)||0):eventPrice(p,normalUnit,displayV)):Number(i.final_price)||0;
        const saleV=p?variantByCartItem(p,i):null,mx=p?stockLimitFor(p,displayV,saleV,dedicated):maxStock(saleV,dedicated),plusDisabled=mx!==99&&i.quantity>=mx;
        return `<div class="s4f-cart-item">
          <img src="${esc((displayV&&displayV.image)||i.image||'')}" alt="">
          <div class="s4f-cart-item__copy"><h4>${esc((p&&p.title)||i.product_title)}</h4><p>${esc((displayV&&displayV.title&&displayV.title!=='Default Title'?displayV.title:(i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:'')))} · ${dedicated?'lot dedicat':(meta.percent?`SPECIAL -${meta.percent}%`:'Sense4FIT')}</p>
          <div class="s4f-cart-item__qty"><button data-line-minus="${esc(i.key)}" data-qty="${i.quantity}" aria-label="Scade cantitatea">−</button><span>${i.quantity}</span><button data-line-plus="${esc(i.key)}" data-qty="${i.quantity}" data-max="${mx}" ${plusDisabled?'disabled':''} aria-label="Crește cantitatea">+</button></div>
          <button class="s4f-cart-item__remove" data-line-remove="${esc(i.key)}">Elimină</button></div>
          <div class="s4f-cart-item__price"><strong>${money(ep*i.quantity)}</strong>${normalUnit>ep?`<del>${money(normalUnit*i.quantity)}</del>`:''}</div>
        </div>`;
      }).join(''):'<div class="s4f-cart-empty"><b>Coșul Sense4FIT este gol.</b><span>Alege un produs de mai jos și îl adăugăm aici.</span></div>';

      $$('[data-line-minus]',items).forEach(b=>b.onclick=()=>changeLine(b.dataset.lineMinus,Math.max(0,Number(b.dataset.qty)-1)));
      $$('[data-line-plus]',items).forEach(b=>b.onclick=()=>{const mx=Number(b.dataset.max)||99;changeLine(b.dataset.linePlus,Math.min(mx,Number(b.dataset.qty)+1));});
      $$('[data-line-remove]',items).forEach(b=>b.onclick=()=>changeLine(b.dataset.lineRemove,0));

      const stats=cartEventStats();
      $$('[data-s4f-count]').forEach(x=>x.textContent=stats.count);
      $$('[data-s4f-cart-count]').forEach(x=>x.textContent=stats.count);
      $$('[data-s4f-sticky-total]').forEach(x=>x.textContent=money(stats.event));
      const subtotal=$('[data-s4f-cart-subtotal]'), savings=$('[data-s4f-cart-savings]'), total=$('[data-s4f-cart-event-total]');
      if(subtotal) subtotal.textContent=money(stats.normal);
      if(savings) savings.textContent=stats.save?'-'+money(stats.save):money(0);
      if(total) total.textContent=money(stats.event);

      const note=$('[data-s4f-main-cart-note]');
      if(note){
        note.hidden=!stats.otherCount;
        note.innerHTML=stats.otherCount?`<b>Ai și ${stats.otherCount} ${stats.otherCount===1?'produs':'produse'} în coșul normal.</b><span>Nu le afișăm aici, dar rămân în checkout-ul Shopify.</span>`:'';
      }

      const sticky=$('[data-s4f-sticky]'); if(sticky) sticky.hidden=!STICKY_ON||!stats.count;
      const checkout=$('[data-s4f-checkout]'); if(checkout) checkout.disabled=!stats.count;

      const shippingMessage=$('[data-s4f-shipping-message]');
      const shippingBar=$('[data-s4f-shipping-bar]');
      const subtotalForShipping=Math.max(0,Number((state.cart&&state.cart.total_price) || stats.event || 0));
      const remaining=Math.max(0,FREE_SHIPPING_THRESHOLD*100 - subtotalForShipping);
      if(shippingBar){
        const pct=FREE_SHIPPING_THRESHOLD>0?Math.min(100,Math.round((subtotalForShipping/(FREE_SHIPPING_THRESHOLD*100))*100)):100;
        shippingBar.style.width=`${pct}%`;
      }
      if(shippingMessage){
        shippingMessage.textContent=remaining>0
          ? `Mai adaugi ${money(remaining)} pentru transport gratuit.`
          : `Ai deblocat transportul gratuit.`;
      }
    }

    function bumpSticky(){
      const sticky=$('[data-s4f-sticky]'); if(!sticky) return;
      sticky.hidden=false; sticky.classList.remove('is-bump'); void sticky.offsetWidth; sticky.classList.add('is-bump');
      setTimeout(()=>sticky.classList.remove('is-bump'),900);
    }

    function openCart(){
      const w=$('[data-s4f-cart-wrap]'); if(!w) return;
      w.classList.add('is-open'); w.setAttribute('aria-hidden','false');
      document.body.classList.add('s4f-cart-open');
      const closeBtn=w.querySelector('[data-s4f-close-cart]'); if(closeBtn)setTimeout(()=>closeBtn.focus(),30);
    }
    function closeCart(){
      const w=$('[data-s4f-cart-wrap]'); if(!w) return;
      w.classList.remove('is-open'); w.setAttribute('aria-hidden','true'); document.body.classList.remove('s4f-cart-open');
    }

    async function applyVoucher(){
      const input=$('[data-s4f-voucher-input]'),status=$('[data-s4f-voucher-status]'); if(!input||!status)return;
      const code=input.value.trim().toUpperCase();
      if(!code){state.voucher='';sessionStorage.removeItem('s4f_activation_voucher');status.textContent='Voucher eliminat.';await applyCartMeta();return;}
      state.voucher=code;sessionStorage.setItem('s4f_activation_voucher',code);status.textContent='Pregătim voucherul…';status.className='s4f-voucher__status';
      try{await applyCartMeta();status.textContent='Voucher adăugat. Shopify validează combinația finală la checkout.';status.className='s4f-voucher__status is-ok';}
      catch(e){status.textContent=e.message||'Voucherul nu a putut fi aplicat.';status.className='s4f-voucher__status is-bad';}
    }
    async function checkout(){
      const b=$('[data-s4f-checkout]'); if(b)b.disabled=true;
      try{await applyCartMeta();window.location.href=ROUTE+'checkout';}
      catch(e){toast(e.message||'Checkout indisponibil','error');if(b)b.disabled=false;}
    }

    // Product UI
    $$('[data-s4f-product]').forEach(card=>{
      initProductCard(card); const ps=state.productStates.get(card.dataset.handle); if(!ps)return;
      const minus=$('[data-s4f-qty-minus]',card),plus=$('[data-s4f-qty-plus]',card),add=$('[data-s4f-add]',card);
      if(minus)minus.onclick=()=>{ps.qty=Math.max(1,ps.qty-1);renderProduct(card,ps)};
      if(plus)plus.onclick=()=>{const dedicated=hasEventProduct(ps.product),saleV=saleVariantFor(ps.product,ps.variant),mx=remainingStockFor(ps.product,ps.variant,saleV,dedicated);ps.qty=Math.min(mx===99?10:Math.max(1,mx),ps.qty+1);renderProduct(card,ps)};
      if(add)add.onclick=()=>addVariant(card,ps);

      // restrained designer parallax, mouse only
      const media=$('.s4f-product__media',card),img=$('.s4f-product__image',card),halo=$('.s4f-product__halo',card);
      if(media&&img&&window.matchMedia('(pointer:fine)').matches){
        media.addEventListener('pointermove',e=>{
          const r=media.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
          img.style.transform=`translate3d(${x*9}px,${y*7}px,0) scale(1.02)`;
          if(halo)halo.style.transform=`translate3d(${x*-13}px,${y*-10}px,0)`;
        });
        media.addEventListener('pointerleave',()=>{img.style.transform='';if(halo)halo.style.transform='';});
      }
    });

    // Filters — resilient in Shopify Theme Editor and live storefront.
    const normalizeCategory=value=>String(value||'').trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/proteine?/g,'protein')
      .replace(/creatina?/g,'creatine')
      .replace(/amino(acizi)?|eaa/g,'amino')
      .replace(/vitamine?|vitamins?/g,'vitamins');

    function applyFilter(rawFilter,activeButton){
      const filter=normalizeCategory(rawFilter||'all');
      $$('[data-s4f-filter]').forEach(button=>{
        const active=button===activeButton || (!activeButton && normalizeCategory(button.dataset.s4fFilter)===filter);
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-selected',active?'true':'false');
      });
      $$('[data-s4f-product]').forEach(card=>{
        const category=normalizeCategory(card.dataset.category);
        const show=filter==='all' || category===filter;
        card.hidden=!show;
        card.classList.toggle('is-filtered-out',!show);
        if(show){
          card.classList.add('is-visible');
          card.classList.remove('is-reveal');
          void card.offsetWidth;
          card.classList.add('is-reveal');
        }
      });
    }

    $$('[data-s4f-filter]').forEach(btn=>{
      btn.setAttribute('aria-selected',btn.classList.contains('is-active')?'true':'false');
      btn.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        applyFilter(btn.dataset.s4fFilter,btn);
      });
    });
    applyFilter('all',$('[data-s4f-filter="all"]'));

    $$('[data-s4f-scroll-products]').forEach(x=>x.onclick=()=>$('#s4f-products-'+ROOT.dataset.sectionId)?.scrollIntoView({behavior:'smooth',block:'start'}));
    $$('[data-s4f-open-cart]').forEach(x=>x.onclick=openCart);
    $$('[data-s4f-close-cart]').forEach(x=>x.onclick=closeCart);

    const voucherInput=$('[data-s4f-voucher-input]');
    if(voucherInput){voucherInput.value=state.voucher;voucherInput.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();applyVoucher();}})}
    const voucherBtn=$('[data-s4f-apply-voucher]'); if(voucherBtn)voucherBtn.onclick=applyVoucher;
    const checkoutBtn=$('[data-s4f-checkout]'); if(checkoutBtn)checkoutBtn.onclick=checkout;
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});

    // Visibility safety: product cards are functional content, not dependent on animation.
    $$('[data-s4f-product],.s4f-step').forEach(el=>el.classList.add('is-visible'));

    // Stable mode: content is visible immediately; no observer-driven reveal.
    $$('[data-s4f-product],.s4f-step').forEach(el=>el.classList.add('is-visible'));

    function trackedInventoryTotal(){
      return PRODUCTS.reduce((sum,p)=>{
        const rules=parsedEventStockRules(p);
        if(rules.length)return sum+rules.reduce((a,r)=>a+Math.max(0,Number(r.qty)||0),0);
        const dedicated=hasEventProduct(p),vars=dedicated?p.eventProduct.variants:p.variants;
        return sum+(vars||[]).reduce((a,v)=>a+(v.available?(v.inventoryManagement==null?0:Math.max(0,Number(v.inventoryQuantity)||0)):0),0);
      },0);
    }
    function renderStockCounter(){
      const totalKnown=trackedInventoryTotal(),dedicatedCount=PRODUCTS.filter(hasEventProduct).length;
      const stockCount=$('[data-s4f-stock-count]');
      if(stockCount)stockCount.textContent=totalKnown?`${totalKnown} bucăți în loturile active`:`Loturi active · disponibilitate pe variante`;
    }
    function refreshProductCards(){
      $$('[data-s4f-product]').forEach(card=>{const ps=state.productStates.get(card.dataset.handle);if(ps){renderOptions(card,ps);renderProduct(card,ps);}});
      renderStockCounter();
    }
    async function refreshInventorySnapshot(){
      try{
        const url=window.location.pathname+'?section_id='+encodeURIComponent(ROOT.dataset.sectionId)+'&_s4f_stock='+Date.now();
        const r=await fetch(url,{credentials:'same-origin',cache:'no-store'}); if(!r.ok)return;
        const html=await r.text(),doc=new DOMParser().parseFromString(html,'text/html'),node=doc.querySelector('[data-s4f-products-json]'); if(!node)return;
        const fresh=JSON.parse(node.textContent||'[]');
        fresh.forEach(fp=>{
          const p=productMap.get(fp.handle); if(!p)return;
          if(Array.isArray(fp.variants)) fp.variants.forEach(fv=>{const v=(p.variants||[]).find(x=>String(x.id)===String(fv.id));if(v)Object.assign(v,{available:fv.available,inventoryQuantity:fv.inventoryQuantity,inventoryPolicy:fv.inventoryPolicy,inventoryManagement:fv.inventoryManagement});});
          if(fp.eventProduct&&hasEventProduct(p)){
            p.eventProduct.available=fp.eventProduct.available;
            (fp.eventProduct.variants||[]).forEach(fv=>{const v=(p.eventProduct.variants||[]).find(x=>String(x.id)===String(fv.id));if(v)Object.assign(v,{available:fv.available,inventoryQuantity:fv.inventoryQuantity,inventoryPolicy:fv.inventoryPolicy,inventoryManagement:fv.inventoryManagement,price:fv.price});});
          }
        });
        refreshProductCards();
      }catch(e){}
    }
    renderStockCounter();
    const stockTimer=setInterval(refreshInventorySnapshot,45000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshInventorySnapshot();});

    getCart().then(()=>applyCartMeta()).then(()=>refreshInventorySnapshot()).catch(()=>renderCart());
  }
})();

/* V3.9.3 stable visual tune — tilt only, never controls visibility */
(()=>{
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
  if(prefersReduced) return;

  function initVisualTune(root){
    if(!root || root.dataset.s4fVisualTune==='1') return;
    root.dataset.s4fVisualTune='1';

    root.querySelectorAll('[data-s4f-product],.s4f-step').forEach(el=>el.classList.add('is-visible'));

    const visual = root.querySelector('.s4f-hero__visual');
    const ticket = root.querySelector('.s4f-hero__ticket');
    if(visual && ticket && finePointer){
      const base = {rx:5, ry:-13, rz:-6};
      const apply = (rx, ry, scale=1)=>{
        ticket.style.transform = `perspective(1500px) rotateY(${ry}deg) rotateX(${rx}deg) rotateZ(${base.rz}deg) scale(${scale})`;
      };
      apply(base.rx, base.ry, 1);
      visual.addEventListener('pointermove', e=>{
        const r = visual.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        apply(base.rx + y * -7, base.ry + x * 16, 1.012);
      });
      visual.addEventListener('pointerleave', ()=>apply(base.rx, base.ry, 1));
    }
  }

  const boot = ()=>document.querySelectorAll('[data-s4f-root]').forEach(initVisualTune);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', e=>{
    const root=e.target?.matches?.('[data-s4f-root]')?e.target:e.target?.querySelector?.('[data-s4f-root]');
    if(root) initVisualTune(root);
  });
})();
